// Auth actions
export const AUTH_SAVE = 'AUTH_SAVE';
export const AUTH_CLEAR = 'AUTH_CLEAR';

// Common actions
export const COMMON_ALERT = 'COMMON_ALERT';
export const COMMON_CLOSE_ALERT = 'COMMON_CLOSE_ALERT';
export const COMMON_MODAL_RESIZE = 'COMMON_MODAL_RESIZE';
export const COMMON_OPEN_CONTACT = 'COMMON_OPEN_CONTACT';
export const COMMON_CLOSE_CONTACT = 'COMMON_CLOSE_CONTACT';
export const COMMON_OPEN_INVITE = 'COMMON_OPEN_INVITE';
export const COMMON_CLOSE_INVITE = 'COMMON_CLOSE_INVITE';
export const COMMON_CONTACT_SENT = 'COMMON_CONTACT_SENT';
export const COMMON_SET_LAST_VISITED = 'COMMON_SET_LAST_VISITED';
export const COMMON_OPEN_NO_ITEM_CONTACT = 'COMMON_OPEN_NO_ITEM_CONTACT';
export const COMMON_CLOSE_NO_ITEM_CONTACT = 'COMMON_CLOSE_NO_ITEM_CONTACT';


// Login actions
// None

// User (global) actions
export const USER_LOGOUT = 'USER_LOGOUT';




// WEBPACK FOOTER //
// ./src/constants/actions.jsx